export default __webpack_public_path__ + "static/media/blue_calendar.6e9da470.svg";